import { action, computed, observable } from 'mobx';
import globalStore from '@/stores';
import { ACCOUNT_TYPE } from '@/constants/Constants';

class HomeStore {
  chartInstance = null;
  @observable todayCostData = {};
  @observable yesterdayCostData = {};
  @observable creativeReviewData = {};

  @computed
  get accountListData() {
    const { agency_list_map } = globalStore.account || {};
    const todayList = this.todayCostData?.list || [];
    const yesterdayList = this.yesterdayCostData?.list || [];
    const creativeList = this.creativeReviewData?.list || [];
    const todayMap = todayList.reduce((map, v) => ({ ...map, [v.agency_uid]: v }), {});
    const yesterdayMap = yesterdayList.reduce((map, v) => ({ ...map, [v.agency_uid]: v }), {});
    const creativeMap = creativeList.reduce((map, v) => ({ ...map, [v.agency_uid]: v }), {});

    return todayList.map(({ agency_uid }) => {
      const { total_cost, total_advertiser, total_balance, ...other } = yesterdayMap[agency_uid] || {};
      const isTechAgency = agency_list_map?.[agency_uid]?.account_type === ACCOUNT_TYPE.tech;
      return {
        ...todayMap[agency_uid] || {},
        ...other || {},
        total_cost_yesterday: total_cost,
        total_advertiser_yesterday: total_advertiser,
        remark: agency_list_map?.[agency_uid]?.remark || '',
        agency_type_name: isTechAgency ? '技术服务商' : (agency_list_map?.[agency_uid]?.agency_type_name || '-'),
        ...creativeMap[agency_uid] || {},
      };
    });
  }

  @action
  setTodayCostData(data) {
    this.todayCostData = data;
  }

  @action
  setYesterdayCostData(data) {
    this.yesterdayCostData = data;
  }

  @action
  setCreativeReviewData(data) {
    this.creativeReviewData = data;
  }

  setChartInstance(chart) {
    this.chartInstance = chart;
  }

  destroyChartInstance() {
    this.chartInstance = null;
  }

  /**
   * @description 重置图表大小
   */
  resizeChart() {
    if (this.chartInstance) {
      this.chartInstance?.setSize(null, null);
    }
  }
}

export default new HomeStore();
